import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useTrpc } from './useTrpc';
export function useIsLoggedIn() {
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var serverEvent = process.server || process.server ? useRequestEvent() : null;
  function isServerLoggedIn() {
    var _serverEvent$node$req, _cookies$find, _vsfCookie$scope;
    var cookieIndex = serverEvent.node.req.rawHeaders.findIndex(function (header) {
      return header === 'cookie';
    });
    if (cookieIndex === -1) {
      return false;
    }
    var cookies = (_serverEvent$node$req = serverEvent.node.req.rawHeaders[cookieIndex + 1]) === null || _serverEvent$node$req === void 0 ? void 0 : _serverEvent$node$req.split(';');
    var rawCookie = (_cookies$find = cookies.find(function (cookie) {
      return cookie.includes('vsf-commercetools-token');
    })) === null || _cookies$find === void 0 ? void 0 : _cookies$find.split('=')[1];
    var decodedCookie = decodeURIComponent(rawCookie);
    if (decodedCookie === 'undefined') {
      return false;
    }
    var vsfCookie = JSON.parse(decodedCookie);
    return ((_vsfCookie$scope = vsfCookie.scope) === null || _vsfCookie$scope === void 0 ? void 0 : _vsfCookie$scope.includes('customer_id')) || !!vsfCookie.sso;
  }
  function isClientLoggedIn() {
    return _isClientLoggedIn.apply(this, arguments);
  }
  function _isClientLoggedIn() {
    _isClientLoggedIn = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.customer.isLoggedIn.query();
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _isClientLoggedIn.apply(this, arguments);
  }
  return {
    isLoggedIn: function isLoggedIn() {
      if (process.server) {
        return isServerLoggedIn();
      }
      return isClientLoggedIn();
    }
  };
}